export default __webpack_public_path__ + "static/media/materialsPrepRed.e7f9470e.svg";